import React from "react"
import {
	checkboxStructure,
	RiskSettingsFieldNames,
	RiskSettingsType,
	showProhibitedBusinessVerticalsAndCountries,
} from "./RiskSettingsUtils"
import AcceptableTypesOfIdentificationViewMode from "./AcceptableTypesOfIdentification/ViewMode/AcceptableTypesOfIdentificationViewMode"
import ProhibitedBusinessVerticalsViewMode from "./ProhibitedBusinessVerticals/VideMode/ProhibitedBusinessVerticalsViewMode"
import ProhibitedCountriesViewMode from "./ProhibitedCountries/ViewMode/ProhibitedCountriesViewMode"

interface RiskSettingsViewModeProps {
	value: RiskSettingsType
	defaultValue?: RiskSettingsType
}

export default function RiskSettingsViewMode({value, defaultValue}: RiskSettingsViewModeProps) {
	return (
		<>
			<AcceptableTypesOfIdentificationViewMode
				value={value[RiskSettingsFieldNames.AcceptableTypesOfIdentification]}
				defaultValue={defaultValue ? defaultValue[RiskSettingsFieldNames.AcceptableTypesOfIdentification] : undefined}
				checkboxStructure={checkboxStructure}
			/>
			{showProhibitedBusinessVerticalsAndCountries && (
				<>
					<ProhibitedBusinessVerticalsViewMode
						value={value[RiskSettingsFieldNames.ProhibitedBusinessVerticals]}
						defaultValue={defaultValue ? defaultValue[RiskSettingsFieldNames.ProhibitedBusinessVerticals] : undefined}
					/>
					<ProhibitedCountriesViewMode
						value={value[RiskSettingsFieldNames.ProhibitedCountries]}
						defaultValue={defaultValue ? defaultValue[RiskSettingsFieldNames.ProhibitedCountries] : undefined}
					/>
				</>
			)}
		</>
	)
}
